import React, { FC, HTMLAttributes, ReactNode } from 'react';
import styles from './Drawer.module.scss';
import { createPortal } from 'react-dom';
import useRemoveBodyScroll from '@/components/houses/_hooks/useRemoveBodyScroll';
interface DrawerProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  open: boolean;
  onClose: () => void;
  anchor?: 'bottom' | 'top' | 'left' | 'right';
  fullHeight?: boolean;
  maxWidth?: string;
  dataAttribute?: string;
  data_cy?: string;
}
const Drawer: FC<DrawerProps> = ({
  children,
  open,
  onClose,
  anchor = 'bottom',
  fullHeight = false,
  maxWidth = '100%',
  dataAttribute,
  data_cy,
  className = '',
  ...props
}) => {
  const handleBackdropClick = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.stopPropagation();
    if (e.target === e.currentTarget && onClose) {
      onClose();
    }
  };
  useRemoveBodyScroll(open);
  if (!open) return null;
  return createPortal(<div data-cy={data_cy} data-modal={dataAttribute} className={styles['drawer']}>
      <div className={styles['backdrop']} onClick={handleBackdropClick}></div>
      <div {...props} className={`${styles['content']} ${styles[anchor]} ${open ? styles['open'] : ''} ${fullHeight ? styles['fullHeight'] : ''} ${className}`} style={{
      maxWidth
    }}>
        {children}
      </div>
    </div>, document.body);
};
export default Drawer;